/**
 * Predicate for seeding create-mode add-on offers from the catalog.
 *
 * An item auto-includes only when it's flagged `offerAsAddon` AND isn't
 * already present as a line item on the quote (line items carry
 * `sourceItemId` referencing `Item.id`, so a lead-picked event option
 * shouldn't also be offered as an add-on). `sourceItemId` is NOT unique
 * across line items - callers must pass Set membership, never `.find`.
 */
export function shouldSeedAddonOffer(
  item: { id: string; offerAsAddon: boolean },
  lineItemSourceIds: Set<string>
): boolean {
  return item.offerAsAddon && !lineItemSourceIds.has(item.id)
}
